<li class=" position-relative" >
    <button class="border rounded py-2 px-3 mb-1 occurrence" [ngClass]="{'selected-occurrence': isSelected}" 
            id="{{occurrence.pollOccurrenceId}}" type="button" 
            [disabled]="occurrence.status !== 'FinishedQuestionStatus'" 
            [matTooltip]="getLiveOccurrenceDateDetail(occurrence)"
            [matTooltipDisabled]="occurrence.status !== 'LiveQuestionStatus'"
            (click)="select(occurrence)">
                <span [matTooltip]="getOccurrenceDateDetail(occurrence)" 
                      [matTooltipDisabled]="occurrence.status === 'LiveQuestionStatus'"
                       class="occurrence-detail col">
                    <i class="fa-regular fa-calendar-range pe-2"></i> {{getOccurrenceDate(occurrence, pollFrequency) }}
                </span>
                <span>
                    @switch (occurrence.status){
                        @case('LiveQuestionStatus'){
                            <small class="ps-3">
                                <i class="fa-solid fa-circle-small text-success px-1"></i>{{ 'polls_settings.occurrence.live' | translate}} {{ getOccurrenceParticipation(occurrence.teams)}}
                            </small>
                        }
                        @case('FinishedQuestionStatus'){
                            @if(getOccurrenceParticipation(occurrence.teams) > 0){
                                <button class="btn btn-outline-primary btn-sm py-1">
                                    <i class="far fa-chart-line pe-1"></i> {{ 'polls_settings.show_results' | translate}} ({{'poll_results.participation' | translate}} {{getOccurrenceParticipation(occurrence.teams)}})
                                </button>
                            }@else{
                                <small class="text-secondary ps-3">
                                    {{ 'polls_settings.show_results.no_participation' | translate}}
                                </small>
                            }
                        }
                    }
                </span>
    </button>
</li>